import {Injectable} from '@angular/core';
import {DataCoreService} from '../../../../services/data-core.service';
import {GenKontrolService} from '../ctl-gen-kontrol.service';

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private genKontrolService: GenKontrolService) {
  }

  getData(control: any, key?: string, customSearch?: string) {
    const columnArray: string[] = control?.searchColumns?.split(',');
    let baseEntity = control?.dlistMetadata?.baseEntity + this.genKontrolService.customQuery;
    if(customSearch?.length > 0)
    {
      if(baseEntity.includes('?')){
        baseEntity = baseEntity + '&search=' + customSearch;
      }
      else {
        baseEntity = baseEntity + '?search=' + customSearch;
      }
    }
    const dataSource = this.dataCoreService.getOData(baseEntity, null, null, key);
    dataSource.select(columnArray);
    const filterArr = [];
     if (control?.donemYn || this.genKontrolService.period) {
      filterArr.push(['Donem', '=', this.genKontrolService.period]);
    }
    if (this.genKontrolService.conditionColName && this.genKontrolService.conditionColText) {
      filterArr.push([this.genKontrolService.conditionColName, '=', this.genKontrolService.conditionColText]);
    } 
    if (this.genKontrolService.controlCondition) {
      this.genKontrolService.controlCondition.forEach((item: any) => {
        filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
      });
    }
    if (this.genKontrolService.normalFilterArr) {
        filterArr.push(this.genKontrolService.normalFilterArr);
    }
    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }
}
